import SearchVisM from './recordm.model.searchvisualization.js';
import UserSettingM from '@cob/ui-genesis/model/cob.user-settings.js';

import ui from '@cob/ui-genesis/cob.ui.js';

// List of _visualizations associated to an entity
var SearchVisGroupM = function(core, entityM, visualizations) {
    this._core = core;
    this._entityM = entityM;
    this._visualizations = [];

    var _this = this;

    visualizations.forEach(function(visualization) {
        _this._visualizations.push(new SearchVisM(core, _this._entityM, visualization));
    });

    core.publish("recordm:search:views:" + _this._entityM.getSettingKey());
};

SearchVisGroupM.loadAll = function(core, settingKey, onDone) {
    var callbacks = {
        success: function(views) {
            if (onDone) {
                onDone(views);
            }
        },
        error: function() {
            ui.notification.showError("An error occured while loading the user settings");
            // If there is an error loading the view continue the process
            onDone([]);
        }
    };

    UserSettingM.loadAll(core, settingKey, "views", callbacks);
};

SearchVisGroupM.prototype.get = function(viewId) {
    var i,
        length = this._visualizations.length;

    for (i = 0; i < length; i++) {
        if (this._visualizations[i].getId() === parseInt(viewId, 10)) {
            return this._visualizations[i];
        }
    }

    return undefined;
};

SearchVisGroupM.prototype.getVisualizations = function() {
    return this._visualizations;
};

SearchVisGroupM.prototype.getByName = function(name) {
    var i,
        length = this._visualizations.length;

    for (i = 0; i < length; i++) {
        if (this._visualizations[i].getName() === name) {
            return this._visualizations[i];
        }
    }

    return undefined;
};

SearchVisGroupM.prototype.add = function(view) {
    var existing = this.get(view.getId()),
        i,
        length = this._visualizations.length;

    if (existing) {
        for (i = 0; i < length; i++) {
            if (this._visualizations[i].getId() === view.getId()) {
                this._visualizations[i] = view;
                return;
            }
        }
    } else {
        this._visualizations.push(view);
    }
};

SearchVisGroupM.prototype.save = function(view) {
    var _this = this;

    view.save(function(viewSaved) {
        _this.add(new SearchVisM(_this._core, _this._entityM, viewSaved));
        _this._core.publish("recordm:settings:" + _this._entityM.getSettingKey() + ":view-saved");
    });
};

SearchVisGroupM.prototype.deleteView = function(viewId) {
    var _this = this;

    this.get(viewId).deleteSelf(function() {
        _this._visualizations = _this._visualizations.filter(function(el) {
            return el.getId() !== viewId;
        });
        _this._core.publish("recordm:settings:" + _this._entityM.getSettingKey() + ":view-deleted", {viewId: viewId});
    });
};

export default SearchVisGroupM;
